<template>
	<v-app-bar app clipped-left clipped-right>
		<v-app-bar-nav-icon v-if="permanent" @click.stop="miniProp = !miniProp">
			<v-icon>{{ miniProp ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
		</v-app-bar-nav-icon>
		<v-app-bar-nav-icon v-if="!permanent" @click.stop="setDrawerBehavior()">
			<v-icon>mdi-menu</v-icon>
		</v-app-bar-nav-icon>
		<slot></slot>
	</v-app-bar>
</template>
<script>
export default {
	name: 'AppBar',
	props: {
		permanent: Boolean,
		mini: Boolean,
		drawerExtended: Boolean,
	},
	data() {
		return {};
	},
	computed: {
		miniProp: {
			get() {
				return this.mini;
			},
			set(value) {
				this.$emit('update:mini', value);
			},
		},
		drawerExtendedProp: {
			get() {
				return this.drawerExtended;
			},
			set(value) {
				this.$emit('update:drawerExtended', value);
			},
		},
	},
	methods: {
		setDrawerBehavior() {
			this.drawerExtendedProp = !this.drawerExtendedProp;
			this.miniProp = false;
		},
	},
};
</script>
